import { inject } from './inject';
import { PaymentCvv as BasePaymentCvv } from './PaymentCvv';

export const PaymentCvv = inject(BasePaymentCvv);
